module.exports = __webpack_public_path__ + "static/media/CTLI_11-178w.301b26ec.webp";